import {
  BasicInfo,
  Documents,
  Terms,
  BusinessPlan,
  BankData
  } from './components';
import { tabs } from './components/basicInfo/tabs';
import { tabsBusinessPlan } from './components/businessPlan/tabsBusinessPlan'

export const Steps = (parseFlag) => {
  return [
    {
      name: 'BASICFORM',
      label: 'Βασικά Στοιχεία',
      Component: BasicInfo,
      subtabs: true,
      tabsComponent : tabs(),
      id: 1,
    },
    {
      name: 'DOCUMENTS',
      label: 'Δικαιολογητικά',
      Component: Documents,
      id: 2,
    },
    {
      name: 'BUSINESSPLAN',
      label: 'Το Επιχειρηματικό μου Σχέδιο',
      Component: BusinessPlan,
      tabsComponent : tabsBusinessPlan(parseFlag),
      id: 3,
    },
    {
      name: 'BANK',
      label: 'Πιστωτικό Ίδρυμα',
      Component: BankData,
      id: 4,
    },
    {
      name: 'TERMS',
      label: 'Όροι & Προϋποθέσεις',
      Component: Terms,
      id: 5,
    },
  ]
};